import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-korrigieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksAufgabeKorrigierenEffects {

    AufgabeKorrigieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_KORRIGIEREN),
        mergeMap((x: ac.PostAufgabeKorrigierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeKorrigieren(x.prueflaufAufgabeAntwortRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeKorrigierenErfolgreichAction(result, x.prueflaufAufgabeAntwortRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeKorrigierenFehlerAction(error, x.prueflaufAufgabeAntwortRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingCommandService);
        }
        return this.service;
    }
}
